// src/components/Media/SecureImage.tsx
// Canonical SecureImage component - consolidated from the former duplicate
// at src/components/SecureMedia/SecureImage.tsx (kept this one since it has
// the actual "secure" behavior: drag/right-click/select prevention, a
// missing-image placeholder, and lazy loading support).
import React from 'react';
import { getSecureMediaStyles } from '../../hooks/useMediaSecurity';

export interface SecureImageProps {
  src?: string;
  secureImageUrl?: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
  onLoad?: () => void;
  onError?: () => void;
  loading?: 'lazy' | 'eager';
  placeholder?: string;
}

const SecureImage: React.FC<SecureImageProps> = ({
  src,
  secureImageUrl,
  alt = '',
  className = '',
  style = {},
  onLoad,
  onError,
  loading = 'lazy',
  placeholder
}) => {
  const imageUrl = secureImageUrl || src;

  if (!imageUrl) {
    return (
      <div
        className={`bg-gray-200 flex items-center justify-center ${className}`}
        style={style}
      >
        <span className="text-gray-500 text-sm">
          {placeholder || 'Image not available'}
        </span>
      </div>
    );
  }

  const secureStyles = {
    ...getSecureMediaStyles(),
    ...style
  };

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={`secure-media ${className}`}
      style={secureStyles}
      loading={loading}
      onLoad={onLoad}
      onError={onError}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
      onSelect={(e) => e.preventDefault()}
      draggable={false}
    />
  );
};

export default SecureImage;
